const libraryKey = (mediaType, metaId) => JSON.stringify([mediaType, metaId]);

module.exports = libraryKey;
module.exports.libraryKey = libraryKey;
